export default __webpack_public_path__ + "static/media/warrior.ad323405.jpg";